import React from 'react';
import { useParams } from 'react-router-dom';
import { useQuery } from '@apollo/client';
import { Grid } from '@mui/material';
import {
  subscriptionQueries
} from '../../../graphql/queries';
import SubscriptionForm from './SubscriptionForm.js';
import Articles from './Articles.js';
import SubscriptionFormWrapper from './SubscriptionFormWrapper.js';

const EditSubscription = () => {
  const { subscriptionId } = useParams();
  const { data } = useQuery(subscriptionQueries.SubscriptionByIdAdmin(subscriptionId), {
    fetchPolicy: 'no-cache'
  });

  if (!data) {
    return null;
  }

  const subscription = { ...data.subscriptionByIdAdmin };

  // Getting yearly/monthly price id
  const getPriceIdForPlan = (plans, type) => {
    const plan = plans.find(plan => plan.type === type);
    return plan.price.id;
  };

  subscription.yearlyPriceId = getPriceIdForPlan(subscription.subscriptionPlans, 'Yearly');
  subscription.monthlyPriceId = getPriceIdForPlan(subscription.subscriptionPlans, 'Monthly');

  return (
    <Grid
      container
      spacing={2}
    >
      <Grid xs={6} item>
        <SubscriptionFormWrapper>
          {({ authors, prices, tags, publishers }) => (
            <SubscriptionForm
              subscription={subscription}
              authors={authors}
              prices={prices}
              tags={tags}
              publishers={publishers}
            />
          )}
        </SubscriptionFormWrapper>
      </Grid>
      <Grid xs={6} item>
        <Articles
          subscription={subscription}
        />
      </Grid>
    </Grid>
  );
};

export default EditSubscription;
